import React from "react";
import Header from "./components/Header.js";
import BookRecommender from "./components/BookRecommender.js";
import Footer from "./components/Footer.js";
import { useState } from "react";

const App = () => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div style={appStyle}>
      <Header isDisabled={isLoading} />
      <BookRecommender setIsLoading={setIsLoading} />
      <Footer isDisabled={isLoading} />
    </div>
  );
};

const appStyle = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
};

export default App;
